<form [formGroup]="form" (keydown)="keyDownFunction($event)">
  <div class="p-fluid">
    <kodit-field fieldLabel="E-Mail / Korisničko ime" fieldLabelFor="email">
      <kodit-text-input
        formCtrlId="email"
        formCtrlType="email"
        [formCtrl]="form.controls.email"
      ></kodit-text-input>
    </kodit-field>

    <kodit-field fieldLabel="Korisnička grupa" fieldLabelFor="grupa">
      <kodit-korisnicka-grupa-dropdown
        formCtrlId="grupa"
        [korisnickaGrupaIdCtrl]="form.controls.roleId | formControl"
        (korisnickaGrupaChanged)="handleRoleChanged($event)"
      ></kodit-korisnicka-grupa-dropdown>
    </kodit-field>

    <kodit-field
      *ngIf="showPoslovneJediniceDropdown"
      fieldLabel="Poslovna jedinica" fieldLabelFor="grupa">
      <kodit-poslovne-jedinice-dropdown
        [poslovnaJedinicaCtrl]="form.controls.poslovnaJedinicaId | formControl"
      >
      </kodit-poslovne-jedinice-dropdown>
    </kodit-field>
  </div>
</form>
